import type { IconName } from "@/components/ui/icon";

export const SCOPE_OPTIONS: {
  value: "c" | "cp" | "p";
  label: string;
  icon: IconName;
}[] = [
  { value: "c", label: "Current Only", icon: "IconClockAlert" },
  { value: "cp", label: "Current + Past", icon: "IconCalendarClock" },
  { value: "p", label: "Past Only", icon: "IconCalendar4" },
];

export const RANGE_MODE_OPTIONS: { value: "exact" | "area"; label: string }[] = [
  { value: "exact", label: "Exact Location" },
  { value: "area", label: "Area Based" },
];

// Keep MI and KM arrays the same length and index-aligned so the
// "Switch to km/mi" toggle in `DistanceDropdown` can convert by index.
export const DISTANCE_OPTIONS_MI = [
  "5 mi",
  "10 mi",
  "15 mi",
  "20 mi",
  "25 mi",
  "50 mi",
  "75 mi",
  "100 mi",
  "150 mi",
  "200 mi",
  "250 mi",
];

export const DISTANCE_OPTIONS_KM = [
  "10 km",
  "15 km",
  "25 km",
  "30 km",
  "40 km",
  "80 km",
  "120 km",
  "160 km",
  "240 km",
  "320 km",
  "400 km",
];

/**
 * Whitelisted distance strings the UI accepts. Used by the assistant agent's
 * apply_filters validation and by per-item location renderers to know whether
 * a value is allowed. Includes both the spaced ("25 mi") and condensed
 * ("25mi") forms because the LLM emits the condensed form per the prompt.
 */
export const ALLOWED_DISTANCES = new Set<string>([
  ...DISTANCE_OPTIONS_MI,
  ...DISTANCE_OPTIONS_KM,
  ...DISTANCE_OPTIONS_MI.map((d) => d.replace(" ", "")),
  ...DISTANCE_OPTIONS_KM.map((d) => d.replace(" ", "")),
]);

/** Default distance used when a city is upgraded from "exact" to "area". */
export const DEFAULT_DISTANCE = "25 mi";

/** Normalize an LLM-emitted distance like "25mi" -> "25 mi" for UI display. */
export function normalizeDistanceForDisplay(raw: string | null | undefined): string {
  if (!raw) return DEFAULT_DISTANCE;
  const trimmed = raw.trim();
  // Insert a space between digits and unit if missing
  const m = /^(\d+(?:\.\d+)?)\s*(mi|km)$/i.exec(trimmed);
  if (!m) return trimmed;
  return `${m[1]} ${m[2].toLowerCase()}`;
}

export const LOCATION_CATEGORY_BADGE: Record<string, string> = {
  country: "COUNTRY",
  region: "STATE",
  city: "CITY",
};
